<template>
  <div class="scoringpaper-wrapper">
    <div v-for="(question, index) in paperQuestion" :key="index">
      <ScoringPaperQuestion
        :questionIndex="index + 1"
        :scoringMethod="question.scoringMethod"
        :scorecard="question.scorecard"
        :answers="question.answers.slice(0, numberOfQuestion)"
        :maximumScore="question.maximumScore"
        :feedbackStatus="question.feedbackStatus"
        :feedbackQuestion="question.feedbackQuestion"
      />
    </div>
  </div>
</template>

<script>
import ScoringPaperQuestion from './ScoringPaperQuestion.vue';

export default {
  name: 'scoringPaperExample',
  props: {
    paperQuestion: { type: Array, default: [] },
    numberOfQuestion: { type: Number, default: 1 },
  },
  components: {
    ScoringPaperQuestion,
  },
};
</script>

<style lang="scss" scoped>
.scoringpaper-wrapper {
  margin-bottom: 20px;
  padding: 20px 3%;
  font-size: 1rem;
}
</style>
